import { Trans, useTranslation } from 'react-i18next';
import useSign from '@/pages/SignLayout.context';
import useViewAndDownload from '@/pages/Sign/useViewAndDownload';
import styles from '../Welcome.module.scss';

const Viewer = () => {
  const { t } = useTranslation(['sign']);
  const { signing, signers, visitor } = useSign();

  const buttons = useViewAndDownload({});

  if (!signing || !signers || !visitor) {
    return null;
  }

  const invitationMessage = signing.invitation?.viewers?.message?.trim();

  return (
    <>
      <div className={styles.p}>
        {t('sign:welcome.viewer.greeting', { name: visitor.name })}
      </div>
      {signing.startedBy && (
        <div className={styles.p}>
          <Trans
            i18nKey="sign:welcome.viewer.introVerbose"
            values={{
              startedName: signing.startedBy.name,
              startedEmail: signing.startedBy.email,
              docName: signing.name,
            }}
            components={{ strong: <strong /> }}
          />
        </div>
      )}
      {!signing.startedBy && (
        <div className={styles.p}>
          <Trans
            i18nKey="sign:welcome.viewer.intro"
            values={{ docName: signing.name }}
            components={{ strong: <strong /> }}
          />
        </div>
      )}

      {invitationMessage && (
        <div className={styles.message}>
          <div className={styles.messageLabel}>
            {t('sign:welcome.messageFrom', {
              name: signing.startedBy?.name ?? '',
            })}
          </div>
          <div className={styles.messageBody}>{invitationMessage}</div>
        </div>
      )}

      {buttons.all}
    </>
  );
};

export default Viewer;
